import { create } from 'zustand';

import { OpenCallService } from '@/services';
import { OpenCallModel } from '@repo/ui/models/index';
import { createInitialState, InitialState } from '@repo/ui/state';

const initialState = createInitialState<OpenCallModel[]>([]);

export interface OpenCallState extends InitialState<OpenCallModel[]> {
  totalCount: number;
  page: number;
  limit: number;
  fetchOpenCalls: (page?: number, limit?: number) => void;
  reset: () => void;
}

let latestRequestId = 0;

export const store = create<OpenCallState>((set) => ({
  data: initialState.data,
  error: initialState.error,
  loading: initialState.loading,
  totalCount: 0,
  page: 1,
  limit: 10,

  fetchOpenCalls: async (page = 1, limit = 10) => {
    const requestId = ++latestRequestId;
    set((state) => ({ ...state, error: '', loading: true }));
    try {
      const response = await OpenCallService.all(page, limit);
      if (requestId !== latestRequestId) return;

      set((state) => ({
        ...state,
        data: response.items as OpenCallModel[],
        totalCount: response.totalCount,
        page,
        limit,
      }));
    } catch (error: unknown) {
      if (requestId !== latestRequestId) return;

      set((state) => ({
        ...state,
        error: (error as Error).message,
      }));
    } finally {
      if (requestId === latestRequestId) {
        set((state) => ({
          ...state,
          loading: false,
        }));
      }
    }
  },

  reset: () => {
    latestRequestId++;
    set((state) => ({
      ...state,
      data: initialState.data,
      loading: initialState.loading,
      error: initialState.error,
      totalCount: 0,
      page: 1,
      limit: 10,
    }));
  },
}));
